import type { BandColor } from '../../types/exercise';

interface BandColorChipProps {
  color: BandColor;
  bandKind: 'long' | 'short';
  compact?: boolean;
}

const BAND_HEX: Record<BandColor, string> = {
  gruen: '#22C55E',
  orange: '#F97316',
  rot: '#EF4444',
  schwarz: '#27272A',
};

const BAND_LABEL: Record<BandColor, string> = {
  gruen: 'Gruen',
  orange: 'Orange',
  rot: 'Rot',
  schwarz: 'Schwarz',
};

const BAND_KIND_LABEL: Record<'long' | 'short', string> = {
  long: 'Langes Band',
  short: 'Kurzes Band',
};

const BAND_KIND_SHORT: Record<'long' | 'short', string> = {
  long: 'L',
  short: 'K',
};

export function BandColorChip({ color, bandKind, compact = false }: BandColorChipProps): JSX.Element {
  const hex = BAND_HEX[color];
  const colorLabel = BAND_LABEL[color];
  const kindLabel = BAND_KIND_LABEL[bandKind];
  const ariaLabel = `Empfohlenes Band: ${colorLabel}, ${kindLabel}`;

  if (compact) {
    return (
      <span
        className="inline-flex h-6 items-center gap-1 rounded-full border border-zinc-200 bg-white px-2 text-xs font-semibold text-zinc-900"
        aria-label={ariaLabel}
      >
        <span
          aria-hidden="true"
          className="size-2.5 rounded-full ring-1 ring-black/10"
          style={{ backgroundColor: hex }}
        />
        {BAND_KIND_SHORT[bandKind]}:{colorLabel}
      </span>
    );
  }

  return (
    <span
      className="inline-flex h-7 items-center gap-2 rounded-full border border-zinc-200 bg-white px-3 text-[13px] font-semibold text-zinc-900"
      aria-label={ariaLabel}
    >
      <span
        aria-hidden="true"
        className="size-3 rounded-full ring-1 ring-black/10"
        style={{ backgroundColor: hex }}
      />
      {kindLabel}: {colorLabel}
    </span>
  );
}
